import type { Response } from '~/types/api/v2'

import { useFetchWithDefaults } from '~/composables/api/useFetchWithDefaults'

import { type DocumentMutationParams, getUrlById as getDocumentByIdUrl } from '../useFetchDocument'

export const useFetchDocumentTermsAndConditions = () => {
  const getUrl = (documentId: string) => `${getDocumentByIdUrl(documentId)}/terms-and-conditions`

  const update = ({
    workspaceId,
    documentId,
    payload,
  }: DocumentMutationParams<App.Data.Payloads.Documents.TermsAndConditionsPayload>) => {
    const { patch } = useFetchWithDefaults()

    return patch<Response<App.Data.Document.Metadata.TermsAndConditionsData>>({
      url: getUrl(documentId),
      workspaceId,
      fetchOptions: {
        body: payload,
      },
    })
  }

  return {
    update,
  }
}
